export const es = {
  // Navigation
  nav: {
    home: "Inicio",
    contact: "Contacto",
    bookNow: "Reservar ahora",
    emergency: "Emergencia 24/7",
    legalNotice: "Aviso Legal",
    implants: "Implantes",
    veneers: "Carillas",
    composite: "Composite Estético",
    technology: "Tecnologías",
    book: "Reservar ahora",
    close: "Cerrar"
  },

  // Common
  common: {
    bookNow: "Reservar",
    date: "Fecha",
    time: "Hora",
    close: "Cerrar"
  },

  // Header
  header: {
    logoText: "SeaDent Mallorca",
    phone: "603 31 96 48",
    whatsapp: "WhatsApp",
    languageToggle: "ES",
    reviews: {
      rating: "5.0",
      count: "470+ reseñas",
      google: "Reseñas de Google"
    }
  },

  // Hero Section
  // Vacaciones / cierre de la clínica — banner en toda la web y aviso dentro
  // del proceso de reserva. {date} se escribe en el idioma activo.
  closure: {
    bannerTitle: 'Disponibilidad limitada',
    bannerShort: 'Reserva online cerrada hasta el {date} incluido. Teléfono y WhatsApp como siempre.',
    bannerText: 'La reserva de citas online está cerrada hasta el {date} incluido. Seguimos atendiéndole por teléfono y WhatsApp como siempre.',
    bookingTitle: 'Reserva online en pausa',
    bookingText: 'Hasta el {date} incluido no se pueden reservar citas aquí. Llámenos o escríbanos por WhatsApp: le buscamos una cita.',
    submitBlocked: 'La reserva online está cerrada para estas fechas. Contacte con nosotros por teléfono o WhatsApp.',
    upcomingTitle: 'Cierre programado',
    upcomingText: 'Del {from} al {until} incluido no es posible reservar online: esos días no aparecen seleccionables en el calendario. Seguimos disponibles por teléfono y WhatsApp.',
    call: 'Llamar',
    whatsapp: 'WhatsApp',
  },

  hero: {
    title: "SeaDent Mallorca: Tu sonrisa importa.",
    subtitle: "Odontología moderna con empatía.",
    cta: "Reservar cita online",
    makeover: {
      title: "Smile Makeover con composite",
      subtitle: "Técnica directa de estratificación a mano alzada – mínimamente invasiva y de belleza natural.",
      cta: "Saber más"
    },
    rotation: {
      on: "Rotación: activada",
      off: "Rotación: desactivada"
    },
    scrollMore: "Saber más",
    ctaClosed: 'Solicitar llamada',
    banner: {
      title: "Experimenta un confort personalizado",
      subtitle: "(y descubre por qué a nuestros pacientes les encanta volver)",
      buttons: {
        cosmetic: "Odontología Estética",
        pediatric: "Odontopediatría",
        general: "Odontología General",
        whitening: "Blanqueamiento Dental"
      }
    }
  },

  // Booking Wizard (3-step flow)
  bookingWizard: {
    steps: {
      treatment: "¿Qué tipo de cita necesita?",
      insurance: "¿Cómo desea pagar?",
      dateTime: "Elija la fecha y hora preferidas"
    },
    treatments: {
      cleaning: "Limpieza Dental Profesional + Examen (Doctor)",
      returningCleaning: "Limpieza Dental para Pacientes Recurrentes (Higienista Dental Registrado) + Examen (Doctor)",
      consultation: "Consulta Dental General (Doctor)",
      cosmetic: "Consulta Dental Estética (Doctor)",
      secondOpinion: "Segunda Opinión en Consulta Dental (Doctor)",
      emergency: "Cita Dental de Urgencia (Radiografías + Examen del Doctor)",
      whitening: "Tratamiento de Blanqueamiento Dental Profesional",
      botox: "Consulta de Botox (Doctor)",
      tmj: "Consulta de ATM (Dolor de Mandíbula) (Doctor)",
      pediatric: "Odontopediatría (Odontología para Niños)"
    },
    insurance: {
      search: "Introduzca su seguro",
      privatePay: "Pago privado",
      privatePayDesc: "Pago personal · no se requiere seguro",
      withInsurance: "A través de mi seguro",
      withInsuranceDesc: "Indique el nombre del seguro"
    },
    navigation: {
      back: "Atrás",
      next: "Siguiente",
      close: "Cerrar"
    },
    notices: {
      leadTimeTitle: "Antelación para citas online",
      leadTime: "Las citas se pueden reservar online a partir de pasado mañana: siempre queda libre al menos un día laborable completo. ¿Lo necesita antes? Llámenos sin compromiso:",
      leadTimeOne: "Entre la reserva y la cita queda libre al menos un día laborable completo: la primera cita disponible online es el {date}. ¿Lo necesita antes? Llámenos sin compromiso:",
      leadTimeMany: "Entre la reserva y la cita quedan libres al menos {days} días laborables completos: la primera cita disponible online es el {date}. ¿Lo necesita antes? Llámenos sin compromiso:",
      leadTimeNone: "La primera cita disponible online es el {date}. ¿Lo necesita aún antes? Llámenos sin compromiso:",
      latestEndTitle: "Hora de finalización máxima",
      latestEnd: "Este tratamiento termina como máximo a las {time}. Por eso la última cita reservable empieza antes."
    },
    getDirections: "Cómo llegar",
    instantBookingBy: "Reserva instantánea por"
  },

  // Form structure used in Step 3 and elsewhere
  booking: {
    title: "Reservar cita",
    subtitle: "Programe su visita con nuestro equipo de expertos",
    form: {
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Número de teléfono",
      message: "Mensaje (opcional)",
      submit: "Confirmar reserva",
      submitting: "Enviando...",
      success: "¡Gracias! Su cita ha sido confirmada.",
      error: "Se ha producido un error al realizar la reserva. Por favor, inténtelo de nuevo."
    }
  },

  // Cookie Consent
  cookieConsent: {
    title: "Aviso de Cookies",
    description: "Utilizamos cookies para mejorar su experiencia en nuestro sitio web. Al utilizar nuestro sitio web, acepta nuestra política de cookies.",
    acceptAll: "Aceptar Todo",
    acceptNecessary: "Solo Necesarias",
    settings: "Configuración",
    save: "Guardar",
    close: "Cerrar",
    privacyPolicy: "Política de Privacidad",
    categories: {
      necessary: {
        title: "Necesarias",
        description: "Estas cookies son necesarias para el funcionamiento del sitio web y no pueden ser desactivadas."
      },
      preferences: {
        title: "Preferencias",
        description: "Estas cookies permiten que el sitio web recuerde las elecciones que ha realizado."
      },
      statistics: {
        title: "Estadísticas",
        description: "Estas cookies nos ayudan a comprender cómo interactúan los visitantes con el sitio web."
      },
      marketing: {
        title: "Marketing",
        description: "Estas cookies se utilizan para proporcionar a los visitantes anuncios y campañas de marketing relevantes."
      }
    }
  },

  // Footer
  footer: {
    legal: {
      title: "Aviso legal",
      privacy: "Política de privacidad",
      cookieSettings: "Configuración de cookies"
    },
    links: {
      title: "Enlaces",
      home: "Inicio",
      contact: "Contacto",
      book: "Reservar cita"
    },
    contact: {
      title: "Contacto",
      practice: "SeaDent Mallorca",
      address: "Avenida de Jaime III № 3",
      city: "07012 Palma, Mallorca",
      owner: "Inhaber: Jan D. Heiringhoff",
      phone: "603 31 96 48",
      whatsapp: "WhatsApp: 603 31 96 48",
      email: "info@seadent.es",
      hours: "Lun-Vie: 09:00 - 18:00"
    },
    copyright: "© {year} SeaDent Mallorca. Todos los derechos reservados."
  },

  // Contact Page content
  contact: {
    title: "Contacto",
    subtitle: "Estaremos encantados de responder a sus preguntas",
    contactInfo: "Información de contacto",
    phone: "Teléfono",
    address: "Dirección",
    email: "Correo electrónico",
    emergencyTitle: "Urgencias",
    emergencyText: "Servicio 24 horas disponible para urgencias",
    appointment: "Cita previa",
    findUsTitle: "Dónde estamos",
    directionsButton: "Cómo llegar",
    transportTitle: "Cómo llegar",
    publicTransport: "Transporte público",
    publicTransportInfo: "Estamos situados en el centro de Palma, cerca de las principales paradas de autobús de Jaime III.",
    byCar: "En coche",
    byCarInfo: "Hay varios aparcamientos públicos cercanos, como el Parking Vía Roma y El Corte Inglés."
  },

  // Emergency Page
  emergency: {
    title: "Servicio de Urgencias Dentales 24/7",
    subtitle: "Estamos aquí para ayudarle las 24 horas del día",
    intro: "Si experimenta una urgencia dental, póngase en contacto con nosotros inmediatamente. Nuestro equipo de urgencias está disponible las 24 horas del día para brindarle la atención que necesita.",
    call: "Llamar ahora",
    whatsapp: "WhatsApp",
    cta: "Llamar al 603 31 96 48",
    details: [
      {
        title: "Disponibilidad",
        description: "Nuestro equipo de urgencias está disponible las 24 horas del día, los 365 días del año, incluidos fines de semana y festivos."
      },
      {
        title: "Contacto",
        description: "Llámenos al 603 31 96 48 para asistencia inmediata. También aceptamos mensajes de WhatsApp."
      },
      {
        title: "Urgencias comunes",
        description: "Tratamos dolores dentales intensos, dientes rotos, pérdida de piezas dentales y otros traumatismos dentales."
      },
      {
        title: "Servicio",
        description: "Brindamos alivio inmediato del dolor y soluciones a largo plazo utilizando la última tecnología dental."
      }
    ],
    common: {
      title: "Urgencias dentales comunes",
      toothache: "Dolor dental intenso",
      broken: "Diente roto o astillado",
      knocked: "Diente caído",
      bleeding: "Sangrado de encías",
      swelling: "Hinchazón facial",
      lost: "Empaste o corona perdida",
      // === Claves comunes de las subpáginas de urgencias (contrato SEO) ===
      breadcrumbHome: "Urgencias",
      callNow: "Llame ahora: 603 31 96 48",
      whatsappCta: "Por WhatsApp: envíenos una foto",
      bookOnline: "Reservar cita online",
      backToHub: "Todas las urgencias: nuestro dentista de urgencias en Palma",
      locationLine: "Avenida de Jaime III 3, 07012 Palma de Mallorca — aparcamiento en Vía Roma y El Corte Inglés.",
      calloutReviews: "5,0 ★ en Google — más de 470 reseñas",
      authorBox: {
        label: "Contenido médico verificado",
        name: "Jan David Heiringhoff",
        credential: "Col·legiat Nº 07001232 — Col·legi Oficial de Dentistes de Balears",
        reviewedLabel: "Revisado médicamente por",
        reviewedDate: "Actualizado: julio de 2026",
      },
      midCta: {
        title: "Llame ahora — estamos en el centro de Palma",
        body: "Avenida de Jaime III 3, con aparcamiento en Vía Roma y El Corte Inglés. Le devolvemos la llamada en menos de 30 minutos.",
        button: "603 31 96 48",
      },
    },
    // === Rediseño v2 (redesign emergency/DESIGN.md) ===
    v2: {
      heroBadge: "DISPONIBLES AHORA • 24/7",
      heroAccent: "Estamos aquí para usted.",
      heroIntro: "Si sufre dolor intenso, un traumatismo dental o un diente roto, nuestro equipo de urgencias le atiende de forma inmediata y empática, 365 días al año.",
      callBtn: "LLAMAR: 603 31 96 48",
      whatsappBtn: "WHATSAPP",
      stats: {
        availability: "Disponibilidad",
        daysAYear: "Días al año",
        responseTime: "Tiempo de respuesta",
        rating: "Valoración pacientes",
      },
      common: {
        title: "Urgencias dentales habituales",
        intro: "La atención inmediata es clave para su salud dental a largo plazo. Tratamos toda urgencia dental con excelencia clínica.",
        eyebrow: "Atención experta en Palma",
        cards: [
          {
            title: "Dolor dental intenso",
            description: "El dolor pulsátil o agudo suele indicar infección o daño nervioso que requiere alivio inmediato.",
            checks: ["Diagnóstico inmediato", "Endodoncia"],
          },
          {
            title: "Traumatismo dental",
            description: "Dientes rotos, astillados o avulsionados por accidente exigen actuar con rapidez para salvar la pieza.",
            checks: ["Reconstrucción urgente", "Reimplantación"],
          },
          {
            title: "Absceso e infección",
            description: "La hinchazón y la fiebre son señales de infecciones graves que requieren antibióticos o cirugía.",
            checks: ["Drenaje de la infección", "Control del dolor"],
          },
        ],
      },
      process: {
        title: "¿Qué hacer en una emergencia?",
        steps: [
          {
            title: "Llámenos enseguida",
            description: "Marque 603 31 96 48 sin demora. Explíquenos brevemente sus síntomas para que preparemos su llegada.",
          },
          {
            title: "Primeros auxilios",
            description: "En caso de dolor: enfríe la zona desde fuera. Si tiene un fragmento dental: consérvelo en leche o saliva.",
          },
          {
            title: "Acuda a la clínica",
            description: "Avenida de Jaime III № 3, Palma — ubicación céntrica para un acceso rápido.",
          },
        ],
      },
      location: {
        eyebrow: "Nuestra clínica",
        title: "SeaDent Mallorca",
        intro: "En el corazón de Palma — atmósfera mediterránea combinada con la mejor tecnología médica.",
        addressLine1: "Avenida de Jaime III № 3",
        addressLine2: "07012 Palma de Mallorca",
        hoursLabel: "Lun – Vie: 09:00 – 18:00",
        emergencyHours: "Teléfono de urgencias: 24/7 disponible",
        directions: "Cómo llegar",
      },
      finalCta: {
        title: "Estamos aquí para usted.",
        intro: "El dolor dental puede ser abrumador. Nuestro equipo está listo para ofrecerle alivio y experiencia — su sonrisa estará en las mejores manos.",
        button: "URGENTE: 603 31 96 48",
      },
    },

    // === Ofensiva SEO urgencias (SEO_NOTFALL_PLAN.md §4.1–4.5) ===
    triage: {
      title: "¿Cuándo debe llamar de inmediato?",
      intro: "No todo tiene la misma urgencia. En caso de duda, llámenos: le orientamos por teléfono sin compromiso.",
      levels: [
        {
          tone: 'now' as const,
          label: "Llame ahora mismo",
          items: [
            "Diente avulsionado (se ha salido entero): cada minuto cuenta",
            "Hinchazón en la cara, fiebre o dificultad para tragar",
            "Sangrado que no se detiene",
            "Dolor insoportable que no le deja descansar",
          ],
        },
        {
          tone: 'today' as const,
          label: "Cita hoy mismo",
          items: [
            "Diente roto o fragmento perdido",
            "Dolor pulsátil que va a más",
            "Corona, carilla o empaste caído",
            "Molestias alrededor de un implante",
          ],
        },
        {
          tone: 'week' as const,
          label: "Esta semana",
          items: [
            "Pequeña fisura o borde astillado sin dolor",
            "Sensibilidad leve al masticar",
            "Sangrado puntual de encías al cepillarse",
          ],
        },
      ],
    },
    hubCards: {
      title: "Urgencias dentales frecuentes — encuentre su situación",
      cards: [
        {
          icon: "sick",
          title: "Dolor de muelas agudo",
          teaser: "Un dolor pulsátil o que le despierta suele indicar una inflamación del nervio que no mejora sola.",
          linkText: "Dolor de muelas insoportable — qué hacer",
          routeKey: "emergency-toothache",
        },
        {
          icon: "dentistry",
          title: "Diente roto o avulsionado",
          teaser: "En la mayoría de los casos podemos reconstruir el diente el mismo día. Si se ha salido entero, los primeros 60 minutos son decisivos.",
          linkText: "¿Se le ha roto un diente? Qué hacer",
          routeKey: "emergency-broken-tooth",
        },
        {
          icon: "emergency",
          title: "Flemón o mejilla hinchada",
          teaser: "Un flemón es una infección que no desaparece por sí sola. La hinchazón o la fiebre exigen actuar hoy.",
          linkText: "Flemón dental — por qué debe actuar hoy",
          routeKey: "emergency-abscess",
        },
        {
          icon: "luggage",
          title: "Urgencia durante su estancia",
          teaser: "¿De visita en Mallorca? Le atendemos con presupuesto por escrito, factura detallada e informe para su dentista habitual.",
          linkText: "Urgencia dental durante su estancia — guía paso a paso",
          routeKey: "emergency-tourists",
        },
        {
          icon: "child_care",
          title: "Accidente dental en niños",
          teaser: "Una caída y un diente dañado: mantenga la calma. Importante: un diente de leche nunca se reimplanta.",
          linkText: "Diente roto en niños — primeros pasos correctos",
          routeKey: "emergency-broken-tooth",
        },
      ],
    },
    weekend: {
      title: "También disponibles en fin de semana, festivos y por la noche",
      paragraphs: [
        "Un problema dental no mira el calendario. Por eso nuestro teléfono de urgencias funciona las 24 horas, los 7 días — también en domingo, festivos y de madrugada. Llame al 603 31 96 48 o escríbanos por WhatsApp: le devolvemos la llamada en menos de 30 minutos.",
        "La consulta (Avenida de Jaime III 3, Palma) abre de lunes a viernes de 9:00 a 18:00. Fuera de ese horario y en fin de semana atendemos urgencias con cita acordada por teléfono: usted llama, nosotros organizamos la visita.",
        "En una verdadera emergencia médica — fiebre alta, dificultad para respirar o tragar — llame primero al 112 (o al 061 en Baleares) y después a nosotros.",
      ],
    },
    hubSolve: {
      title: "Así lo resolvemos en SeaDent",
      items: [
        {
          problem: "Diente roto o astillado",
          solution: "Reconstrucción directa con composite en una sola sesión: sin tallar el diente y con resultado el mismo día.",
          linkText: "Reconstrucción con composite en una sesión",
          routeKey: "composite",
        },
        {
          problem: "Dolor de muelas agudo",
          solution: "Radiografía digital y endodoncia de urgencia bajo microscopio dental, con láser para desinfectar los conductos.",
          linkText: "Nuestra tecnología: microscopio, láser y radiografía 3D",
          routeKey: "technologies",
        },
        {
          problem: "Problemas con un implante",
          solution: "Diagnóstico digital y planificación asistida por ordenador — también si el implante se lo colocaron en otra clínica.",
          linkText: "Implantes dentales en SeaDent",
          routeKey: "implants",
        },
      ],
    },
    hubFaq: {
      title: "Preguntas frecuentes sobre nuestro servicio de urgencias",
      items: [
        {
          q: "¿Cuánto cuesta una cita de urgencia?",
          a: "Depende del tratamiento. Antes de empezar recibe un presupuesto por escrito — sin sorpresas. Aceptamos tarjeta y le entregamos una factura detallada para su mutua o seguro.",
        },
        {
          q: "¿Atienden en domingo o en festivos?",
          a: "El teléfono de urgencias funciona las 24 horas, también en domingo y festivos. Las citas fuera del horario de consulta se acuerdan por teléfono — le devolvemos la llamada en menos de 30 minutos.",
        },
        {
          q: "¿Se me ha roto una corona — pueden repararla?",
          a: "Sí. Según el caso, la volvemos a cementar, la reparamos con composite o preparamos una nueva con escaneado digital. Traiga la pieza si la conserva.",
        },
        {
          q: "¿Me duele un implante que me colocaron en otra clínica — me pueden tratar?",
          a: "Por supuesto, aunque se haya colocado en otro país. Con radiografía digital 3D localizamos la causa, fijamos coronas sueltas y tratamos la inflamación.",
        },
        {
          q: "¿Hacen endodoncias de urgencia?",
          a: "Sí — a menudo es la única forma de detener el dolor y salvar el diente. Trabajamos bajo microscopio dental y con láser, con tasas de éxito claramente superiores.",
        },
        {
          q: "¿Me sangran las encías — es una urgencia?",
          a: "Un sangrado puntual al cepillarse no suele serlo. Si es abundante, hay hinchazón o dolor, o no se detiene tras una extracción, llámenos hoy mismo.",
        },
        {
          q: "¿En qué idiomas me pueden atender?",
          a: "En español, alemán e inglés — desde la primera llamada hasta el informe final.",
        },
      ],
    },
    homeTeaser: {
      title: "¿Urgencia dental? Estamos disponibles — teléfono 24/7",
      body: "Dolor de muelas insoportable, un diente roto o un flemón: le atendemos también en fin de semana y festivos con cita acordada por teléfono. Llame al 603 31 96 48 — le devolvemos la llamada en menos de 30 minutos.",
      linkText: "Dentista de urgencias en Palma — toda la información",
    },
    footerTitle: "Urgencias",

    brokenTooth: {
      breadcrumb: "Diente roto",
      h1: "¿Se le ha roto un diente en Mallorca? Podemos reconstruirlo — ayuda inmediata en Palma",
      heroIntro: "Duele, asusta y siempre pasa en el peor momento — respire hondo: para casi todos los accidentes dentales hay una buena solución, a menudo el mismo día. En la mayoría de los casos podemos reconstruir el diente en una sola sesión, sin corona y sin tallar.",
      heroNote: "Envíenos una foto del diente por WhatsApp — le decimos de inmediato qué hacer.",
      warnbox: {
        title: "¿El diente se ha salido entero? Los primeros 60 minutos deciden",
        body: "Un diente avulsionado (que se ha salido completo, con raíz) tiene las mejores probabilidades de reimplantarse con éxito dentro de los primeros 60 minutos. Guárdelo en leche o en su propia saliva y llámenos mientras viene de camino: 603 31 96 48.",
      },
      sections: [
        {
          icon: "healing",
          title: "Primeros auxilios en 4 pasos",
          intro: "Lo que haga en los próximos minutos puede decidir si el diente se salva. Siga estos cuatro pasos — y llámenos en paralelo.",
          items: [
            {
              title: "1. Guarde el diente o el fragmento en leche o saliva",
              body: "La leche fría es el mejor medio de transporte doméstico; también sirve la propia saliva (por ejemplo, dentro de la mejilla en adultos). Si dispone de una cajita de rescate dental de farmacia, aún mejor. Nunca lo transporte en seco ni en agua del grifo.",
            },
            {
              title: "2. Toque el diente solo por la corona",
              body: "Sujete el diente únicamente por la parte blanca visible, nunca por la raíz. En la raíz hay células vivas que son imprescindibles para que el diente vuelva a agarrar.",
            },
            {
              title: "3. No lo limpie ni lo frote",
              body: "Aunque el diente haya caído al suelo: no lo frote, no lo desinfecte y no le quite restos de tejido. Lo que parece suciedad puede ser justo el tejido que necesitamos conservar.",
            },
            {
              title: "4. Aplique frío desde fuera",
              body: "Una compresa fría envuelta en un paño sobre la mejilla alivia el dolor y frena la hinchazón. Nunca aplique hielo directamente sobre la piel ni sobre el diente.",
            },
          ],
        },
        {
          icon: "table_chart",
          title: "¿Roto, avulsionado o aflojado? Qué significa cada caso",
          intro: "No todos los traumatismos dentales son iguales. Esta tabla le ayuda a clasificar su situación en segundos:",
          table: {
            headers: ["Situación", "Qué significa", "Qué hacer", "Urgencia"],
            rows: [
              [
                "Diente roto o astillado",
                "Se ha desprendido un fragmento; la raíz sigue en su sitio",
                "Guardar el fragmento en leche o saliva y pedir cita hoy",
                "Hoy mismo",
              ],
              [
                "Diente avulsionado",
                "El diente se ha salido entero, con raíz",
                "Guardarlo en leche o saliva, no tocar la raíz y llamar de inmediato",
                "Ahora — ventana de 60 minutos",
              ],
              [
                "Diente aflojado o desplazado",
                "El diente se mueve o ha cambiado de posición tras un golpe",
                "No moverlo con la lengua ni morder con él; acudir hoy para ferulizarlo",
                "Hoy mismo",
              ],
            ],
          },
        },
        {
          icon: "diamond",
          title: "¿Se le ha roto una corona o una carilla?",
          intro: "Una corona desprendida o una carilla fracturada no es solo un problema estético: el diente queda desprotegido frente a la temperatura y las bacterias. Traiga la pieza si la conserva — según el caso, volvemos a cementar la corona, reparamos la carilla con composite o tomamos una impresión digital para fabricar una nueva. Hasta la cita, evite masticar por ese lado y proteja la pieza en una bolsita limpia.",
        },
      ],
      solve: {
        title: "Así lo resolvemos en SeaDent: reconstrucción en una sola sesión",
        intro: "Nuestra especialidad es la reconstrucción directa con composite — la solución ideal para dientes rotos o astillados:",
        points: [
          {
            title: "Resultado el mismo día",
            body: "Reconstruimos la forma, la longitud y el color de su diente en una única sesión, con técnica de estratificación a mano alzada. Sin laboratorio, sin provisional, sin segunda cita.",
          },
          {
            title: "Sin tallar y reversible",
            body: "No reducimos su diente natural: solo añadimos material. Todas las opciones futuras siguen abiertas — y si más adelante se rompe otro fragmento, lo reparamos de forma puntual, sin necesidad de una corona nueva.",
          },
          {
            title: "Reimplantación y ferulización",
            body: "Si el diente se ha salido entero, lo reimplantamos y lo estabilizamos con una férula, con control bajo el microscopio dental. Por eso cuenta cada minuto: llame mientras viene de camino.",
          },
        ],
        links: [
          { text: "Reconstrucción directa con composite — así funciona", routeKey: "composite" },
          { text: "Urgencia dental durante su estancia en Mallorca — costes y pago", routeKey: "emergency-tourists" },
        ],
      },
      faq: {
        title: "Preguntas frecuentes: diente roto",
        items: [
          {
            q: "¿Cuánto tiempo tengo para salvar el diente?",
            a: "Un diente avulsionado tiene las mejores probabilidades dentro de los primeros 60 minutos, bien conservado en leche o saliva. Un fragmento roto es menos urgente, pero cuanto antes venga, mejor podremos reutilizarlo o reconstruir el diente.",
          },
          {
            q: "¿Cuánto cuesta la reconstrucción?",
            a: "Depende del tamaño del daño y del número de dientes afectados. Antes de empezar recibe siempre un presupuesto por escrito, y le entregamos una factura detallada para su mutua o seguro privado.",
          },
          {
            q: "¿Y si le ha pasado a mi hijo? ¿Y si es un diente de leche?",
            a: "Importante: un diente de leche nunca se reimplanta, porque podría dañar el diente definitivo que crece debajo. Guarde la calma, aplique frío y llámenos — le decimos por teléfono si hace falta venir hoy. Si se trata de un diente definitivo (a partir de los 6–7 años aproximadamente), valen los mismos pasos que para los adultos: leche o saliva y venir de inmediato.",
          },
          {
            q: "¿Mi seguro o mi mutua cubre el tratamiento?",
            a: "Le entregamos una factura detallada con diagnóstico y tratamiento, además de las radiografías si las necesita, para que pueda presentarlo a su mutua o seguro dental privado. Las condiciones de reembolso dependen de su póliza.",
          },
          {
            q: "¿La reconstrucción con composite es duradera?",
            a: "Sí. Con buena higiene y revisiones periódicas, las reconstrucciones de composite pueden durar muchos años — y si algún día se daña una zona, la reparamos puntualmente sin rehacer todo el trabajo.",
          },
        ],
      },
      finalCta: {
        title: "No espere — cuanto antes venga, más opciones tiene su diente",
        body: "Llame ahora al 603 31 96 48 o envíenos una foto por WhatsApp. Le devolvemos la llamada en menos de 30 minutos y le decimos exactamente qué hacer.",
      },
    },

    toothache: {
      breadcrumb: "Dolor de muelas",
      h1: "¿Dolor de muelas insoportable? Nos tomamos su dolor en serio — cita urgente en Palma",
      heroIntro: "Quien no lo ha vivido no lo entiende: un dolor de muelas fuerte lo domina todo. No tiene que aguantarlo ni «esperar a que pase». Llámenos — le devolvemos la llamada en menos de 30 minutos y buscamos una cita urgente, muchas veces el mismo día.",
      heroNote: "También por WhatsApp: descríbanos sus síntomas y le orientamos de inmediato.",
      sections: [
        {
          icon: "warning",
          title: "¿Cuándo es el dolor de muelas una urgencia?",
          intro: "Estas señales de alarma indican que no debe esperar:",
          items: [
            {
              title: "Dolor pulsátil que late al ritmo del corazón",
              body: "Suele indicar una inflamación del nervio (pulpitis). Sin tratamiento, la inflamación avanza y puede acabar en un flemón.",
            },
            {
              title: "El dolor le despierta o no le deja dormir",
              body: "Un dolor que se intensifica al tumbarse es una señal típica de inflamación avanzada del nervio — pida cita hoy.",
            },
            {
              title: "Hinchazón o fiebre",
              body: "Mejilla hinchada, fiebre o dificultad para tragar apuntan a un flemón dental. En ese caso, consulte también nuestra página sobre el flemón — y llame de inmediato.",
            },
            {
              title: "Dolor intenso al morder o al contacto con frío y calor",
              body: "Puede indicar caries profunda, una fisura en el diente o un empaste dañado. Cuanto antes lo veamos, más sencillo suele ser el tratamiento.",
            },
          ],
        },
        {
          icon: "bedtime",
          title: "Dolor de muelas por la noche: por qué empeora y cómo aguantar hasta la cita",
          intro: "Muchos pacientes nos cuentan lo mismo: durante el día se soporta, por la noche se vuelve insoportable. Tiene explicación: al tumbarse aumenta la presión sanguínea en la cabeza y la inflamación presiona más sobre el nervio. Además, por la noche no hay distracciones — el dolor ocupa todo el primer plano.",
          items: [
            {
              title: "Duerma con la cabeza elevada",
              body: "Una almohada adicional reduce la presión en la zona inflamada y suele aliviar de forma notable.",
            },
            {
              title: "Aplique frío desde fuera",
              body: "Una compresa fría envuelta en un paño sobre la mejilla, en intervalos de unos 10 minutos. Evite el calor: puede acelerar una inflamación.",
            },
            {
              title: "Analgésicos: solo como puente honesto hasta la cita",
              body: "Los analgésicos de venta libre pueden ayudar a corto plazo — lea el prospecto o consulte en la farmacia, y díganos antes del tratamiento qué ha tomado. Importante: los preparados con ácido acetilsalicílico pueden aumentar la tendencia al sangrado. Ningún analgésico elimina la causa: el dolor volverá mientras no se trate.",
            },
          ],
        },
        {
          icon: "search",
          title: "Causas frecuentes del dolor de muelas agudo",
          items: [
            {
              title: "Pulpitis (inflamación del nervio)",
              body: "La causa más habitual del dolor intenso y pulsátil. El nervio inflamado dentro del diente no tiene espacio para expandirse — de ahí la intensidad del dolor. Suele requerir una endodoncia de urgencia.",
            },
            {
              title: "Caries profunda",
              body: "Cuando la caries alcanza la cercanía del nervio, aparecen dolores al frío, al calor y al masticar. Detectada a tiempo, a menudo basta con un empaste.",
            },
            {
              title: "Fisura o fractura del diente",
              body: "Una grieta fina puede ser invisible a simple vista y causar dolores punzantes al morder. Con el microscopio dental y la radiografía digital la localizamos con precisión.",
            },
            {
              title: "Flemón dental (absceso)",
              body: "Si a los dolores se suman hinchazón o fiebre, probablemente se ha formado un foco de pus. Es la escalada más seria — actúe hoy.",
            },
          ],
        },
      ],
      solve: {
        title: "Así lo resolvemos en SeaDent: parar el dolor y salvar el diente",
        intro: "Su diente no es para nosotros un caso para el fórceps — intentamos siempre conservarlo primero:",
        points: [
          {
            title: "Diagnóstico inmediato con radiografía digital 3D",
            body: "Localizamos la causa exacta de su dolor con imagen digital de baja radiación — la base para tratar en la misma cita.",
          },
          {
            title: "Endodoncia de urgencia bajo el microscopio dental",
            body: "El tratamiento de conductos bajo microscopio alcanza tasas de éxito claramente superiores: vemos lo que otros no ven. En la mayoría de los casos, el dolor desaparece el mismo día.",
          },
          {
            title: "Láser dental para desinfectar los conductos",
            body: "El láser elimina bacterias en los conductos radiculares de forma mínimamente invasiva y mejora el pronóstico del diente a largo plazo.",
          },
        ],
        links: [
          { text: "Nuestra tecnología: microscopio dental, láser y radiografía 3D", routeKey: "technologies" },
          { text: "¿Mejilla hinchada o fiebre? Flemón dental — actúe hoy", routeKey: "emergency-abscess" },
        ],
      },
      faq: {
        title: "Preguntas frecuentes: dolor de muelas agudo",
        items: [
          {
            q: "¿Me pueden dar cita hoy mismo?",
            a: "En caso de urgencia, casi siempre sí. Llame al 603 31 96 48 — le devolvemos la llamada en menos de 30 minutos y organizamos la cita más rápida posible, muchas veces el mismo día.",
          },
          {
            q: "¿Cuánto cuesta el tratamiento?",
            a: "Depende de la causa: no es lo mismo un empaste que una endodoncia. Tras el diagnóstico recibe un presupuesto por escrito antes de cualquier tratamiento, y una factura detallada para su mutua o seguro.",
          },
          {
            q: "¿Sirven de algo los remedios caseros?",
            a: "Enjuagues suaves, frío desde fuera y la cabeza elevada pueden aliviar unas horas — nada más. Ningún remedio casero elimina una inflamación del nervio. Úselos como puente hasta la cita, no como sustituto.",
          },
          {
            q: "¿Y si me pasa en fin de semana?",
            a: "Nuestro teléfono de urgencias funciona las 24 horas, también en sábado, domingo y festivos. Las citas fuera del horario de consulta se acuerdan por teléfono — toda la información está en nuestra página principal de urgencias.",
          },
        ],
      },
      finalCta: {
        title: "El dolor de muelas no mejora esperando — nosotros sí podemos pararlo",
        body: "Llame ahora al 603 31 96 48 o escríbanos por WhatsApp. Le devolvemos la llamada en menos de 30 minutos.",
      },
    },

    tourists: {
      breadcrumb: "Turistas y visitantes",
      h1: "Urgencia dental durante su estancia en Mallorca — guía paso a paso",
      heroIntro: "Una urgencia dental lejos de casa es doblemente estresante: duele y no sabe a quién acudir. Aquí tiene su plan. Le atendemos en español, alemán e inglés, en el centro de Palma — y en la mayoría de los casos podrá continuar su estancia con normalidad.",
      heroNote: "El camino más rápido: envíenos una foto o un mensaje por WhatsApp y le decimos de inmediato cómo proceder.",
      sections: [
        {
          icon: "format_list_numbered",
          title: "Las 4 urgencias más frecuentes durante las vacaciones",
          intro: "Estos son los problemas que más vemos en visitantes — con el primer paso correcto en cada caso:",
          items: [
            {
              title: "Dolor de muelas agudo",
              body: "Frío desde fuera, cabeza elevada por la noche — y cita urgente, porque una inflamación del nervio no mejora sola. Toda la información en nuestra página sobre el dolor de muelas.",
            },
            {
              title: "Diente roto o astillado",
              body: "Guarde el fragmento en leche o saliva y llámenos: a menudo reconstruimos el diente el mismo día. Los pasos exactos, en nuestra página sobre el diente roto.",
            },
            {
              title: "Empaste o corona perdida",
              body: "Conserve la pieza, no mastique por ese lado y pida cita hoy o mañana: el diente desprotegido es sensible y vulnerable.",
            },
            {
              title: "Flemón o mejilla hinchada",
              body: "Una infección con hinchazón no admite espera — y con fiebre o dificultad para tragar, llame primero al 112 (o al 061 en Baleares). Más detalles en nuestra página sobre el flemón dental.",
            },
          ],
        },
        {
          icon: "payments",
          title: "Costes, pago y factura — sin sorpresas",
          intro: "Nadie tiene presupuestada una urgencia dental en su viaje. Por eso trabajamos con total transparencia: tras el diagnóstico recibe un presupuesto por escrito antes de cualquier tratamiento — usted decide con toda la información. Puede pagar con tarjeta, y le entregamos una factura detallada con diagnóstico y desglose, válida para presentar a su mutua o a su seguro dental privado; las condiciones de reembolso dependen de su póliza. Si nos visita desde la península, le tratamos exactamente igual que a nuestros pacientes habituales de Palma — sin trámites adicionales.",
        },
        {
          icon: "directions",
          title: "Cómo llegar desde su alojamiento",
          intro: "Nos encontrará en plena Avenida de Jaime III 3, 07012 Palma — la avenida comercial más conocida del centro, fácil de indicar a cualquier taxista. Desde la Playa de Palma, Alcúdia o Port d'Andratx se llega cómodamente en taxi o en las líneas de autobús que conectan con el centro de Palma. Si viene en coche, tiene aparcamiento en Vía Roma y en El Corte Inglés, a pocos minutos a pie.",
        },
        {
          icon: "settings_suggest",
          title: "Problemas con un implante — también si se lo colocaron en otra clínica",
          intro: "¿Le duele un implante o se ha aflojado la corona durante su estancia? Le tratamos aunque el implante se haya colocado en otra clínica o en otro país. Con radiografía digital 3D y planificación asistida por ordenador localizamos la causa, volvemos a fijar coronas sueltas y controlamos la inflamación — para que el problema no le estropee el viaje.",
        },
      ],
      solve: {
        title: "Así lo resolvemos en SeaDent: para que pueda continuar su estancia",
        intro: "Nuestro objetivo con los visitantes es claro: resolver el problema de forma definitiva o dejarlo estable, para que disfrute del resto de su viaje:",
        points: [
          {
            title: "Tratamiento definitivo en una sesión siempre que sea posible",
            body: "Un diente roto lo reconstruimos con composite en una sola cita — sin provisionales que se caen a mitad del viaje ni odiseas de varias visitas.",
          },
          {
            title: "Informe y radiografías para su dentista habitual",
            body: "Le entregamos un informe del tratamiento y sus radiografías, para que su dentista de siempre pueda continuar el seguimiento sin repetir pruebas.",
          },
          {
            title: "Atención en su idioma",
            body: "Español, alemán e inglés — desde la primera llamada hasta la factura. Sin malentendidos en un momento en el que necesita claridad.",
          },
        ],
        links: [
          { text: "Reconstrucción con composite en una sola sesión", routeKey: "composite" },
          { text: "Implantes dentales en SeaDent Mallorca", routeKey: "implants" },
        ],
      },
      faq: {
        title: "Preguntas frecuentes de visitantes",
        items: [
          {
            q: "¿Puedo pagar con tarjeta?",
            a: "Sí, aceptamos pago con tarjeta. Recibe siempre un presupuesto por escrito antes del tratamiento y una factura detallada después.",
          },
          {
            q: "¿Podré volar después del tratamiento?",
            a: "Tras la mayoría de los tratamientos puede volar con normalidad. Se lo confirmamos de forma individual según su caso — díganos su fecha de vuelo y lo tenemos en cuenta al planificar.",
          },
          {
            q: "¿Me dan documentación para mi mutua o seguro?",
            a: "Sí: factura detallada con diagnóstico y desglose del tratamiento, y las radiografías si las necesita. Con ello puede solicitar el reembolso según las condiciones de su póliza.",
          },
          {
            q: "¿Me pueden atender el mismo día de mi salida?",
            a: "Llámenos lo antes posible e indíquenos su hora de salida: organizamos la cita para que le dé tiempo con margen. En urgencias intentamos siempre encontrar un hueco el mismo día.",
          },
        ],
      },
      finalCta: {
        title: "Que un diente no le estropee el viaje — le ayudamos hoy",
        body: "Llame al 603 31 96 48 o escríbanos por WhatsApp con una foto. Le devolvemos la llamada en menos de 30 minutos — en su idioma.",
      },
    },

    abscess: {
      breadcrumb: "Flemón dental",
      h1: "¿Flemón o mejilla hinchada? Actúe hoy — estamos disponibles",
      heroIntro: "Una mejilla hinchada con dolor no es «algo que ya bajará»: detrás suele haber un flemón dental — un foco de pus causado por una infección. La buena noticia: tratado a tiempo, se resuelve bien y el alivio llega rápido. Lo importante es actuar hoy.",
      heroNote: "Llámenos y descríbanos la hinchazón — le decimos de inmediato qué hacer.",
      warnbox: {
        title: "¿Cuándo llamar antes al servicio de emergencias?",
        body: "Si tiene fiebre, dificultad para tragar, dificultad para respirar o la hinchazón avanza hacia el ojo o el cuello: llame de inmediato al 112 (o al 061 en Baleares) — y después a nosotros.",
      },
      sections: [
        {
          icon: "visibility",
          title: "Reconocer los síntomas: ¿es un flemón?",
          intro: "El flemón dental — llamado en odontología absceso dental — no siempre se presenta igual. Estas son las formas más habituales:",
          items: [
            {
              title: "Flemón de origen dental",
              body: "Dolor pulsátil intenso, mejilla hinchada y a menudo sensación de que el diente «ha crecido» y choca antes al morder. La causa suele ser un nervio infectado o una caries profunda no tratada.",
            },
            {
              title: "Absceso de la encía",
              body: "Hinchazón localizada y dolorosa en la encía, a veces con un punto blanquecino. Puede originarse en una bolsa periodontal o por un resto de comida incrustado.",
            },
            {
              title: "Irritación pasajera",
              body: "Una encía enrojecida que sangra levemente al cepillarse no es un flemón, pero sí una señal de revisión. La diferencia clave: el flemón duele, se hincha y empeora — la irritación mejora en pocos días.",
            },
          ],
        },
        {
          icon: "hourglass_bottom",
          title: "Por qué esperar es peligroso",
          intro: "Se lo decimos con claridad y sin alarmismo: un flemón no desaparece solo. El pus está encerrado en el tejido y la infección busca camino — hacia el hueso, hacia los tejidos blandos de la cara o el cuello. Que el dolor disminuya de repente no es una buena señal: puede significar que el absceso se ha abierto hacia dentro. Los enjuagues y los remedios caseros pueden aliviar la superficie, pero no llegan al foco de la infección. Cada día de espera hace el tratamiento más complejo — y tratado hoy, suele ser un procedimiento rápido con alivio casi inmediato.",
        },
        {
          icon: "recommend",
          title: "Qué puede hacer hasta la cita",
          items: [
            {
              title: "Aplique frío — nunca calor",
              body: "Una compresa fría envuelta en un paño sobre la mejilla frena la hinchazón y alivia. El calor es contraproducente: favorece la multiplicación de las bacterias y la expansión de la infección.",
            },
            {
              title: "No pinche ni presione el flemón",
              body: "Nunca intente abrir o vaciar el absceso usted mismo: puede empujar los gérmenes hacia el tejido más profundo y agravar la infección. El drenaje es un procedimiento estéril que realizamos en la clínica.",
            },
            {
              title: "Cabeza elevada y comida blanda",
              body: "Duerma con la cabeza elevada para reducir la presión en la zona, evite masticar por ese lado y prefiera alimentos blandos y templados.",
            },
          ],
        },
      ],
      solve: {
        title: "Así lo resolvemos en SeaDent: eliminar la infección y tratar la causa",
        intro: "El tratamiento de un flemón tiene dos objetivos: aliviarle hoy y evitar que vuelva:",
        points: [
          {
            title: "Drenaje y alivio inmediato",
            body: "Abrimos el absceso de forma controlada y estéril, con anestesia local. La presión desaparece — y con ella la mayor parte del dolor, normalmente el mismo día.",
          },
          {
            title: "Láser dental contra los gérmenes",
            body: "Utilizamos el láser para la reducción bacteriana y el control del sangrado — un tratamiento más suave y con mejor cicatrización.",
          },
          {
            title: "Tratar la causa bajo el microscopio",
            body: "Un flemón siempre tiene una causa — muchas veces un nervio infectado. Con la endodoncia bajo microscopio dental eliminamos el origen para que la infección no regrese. Y sobre los antibióticos: solo tras la valoración del dentista y como apoyo — un antibiótico por sí solo no elimina el foco de la infección.",
          },
        ],
        links: [
          { text: "Nuestra tecnología: láser dental y microscopio", routeKey: "technologies" },
          { text: "¿Dolor de muelas sin hinchazón? Cita urgente en Palma", routeKey: "emergency-toothache" },
        ],
      },
      faq: {
        title: "Preguntas frecuentes: flemón dental",
        items: [
          {
            q: "¿Puede desaparecer un flemón por sí solo?",
            a: "No. Aunque el dolor baje temporalmente, el foco de pus permanece y la infección puede extenderse. Un flemón necesita siempre tratamiento odontológico — cuanto antes, más sencillo.",
          },
          {
            q: "¿Me pueden recetar antibióticos sin cita?",
            a: "No, y es por su seguridad: el antibiótico por sí solo no elimina el absceso, y sin explorarle no podemos saber qué tratamiento necesita. La decisión sobre antibióticos la toma el dentista tras el diagnóstico, como apoyo al tratamiento — no como sustituto.",
          },
          {
            q: "¿Cuánto cuesta el tratamiento?",
            a: "Depende del alcance: drenaje, tratamiento de la causa o ambos. Tras el diagnóstico recibe un presupuesto por escrito antes de empezar, y una factura detallada para su mutua o seguro.",
          },
          {
            q: "¿Puedo volar con un flemón?",
            a: "No es recomendable: los cambios de presión en el avión pueden intensificar el dolor, y una infección activa debe tratarse antes de viajar. Venga a vernos primero — en muchos casos el tratamiento es rápido y después podrá viajar con tranquilidad.",
          },
        ],
      },
      finalCta: {
        title: "Un flemón no espera — nosotros tampoco",
        body: "Llame ahora al 603 31 96 48. Le devolvemos la llamada en menos de 30 minutos y le damos cita lo antes posible — también en fin de semana con acuerdo telefónico.",
      },
    },
  },

  // Treatments Section
  treatments: {
    title: "Tratamientos: Su sonrisa en las mejores manos",
    intro: "Nuestros tratamientos en SeaDent Mallorca cubren todo el espectro de la odontología moderna, desde la prevención hasta la perfección estética. Con tecnología avanzada y un cuidado empático, garantizamos su salud oral y una sonrisa radiante.",
    cta: "Reservar cita",
    categories: [
      {
        title: "Prevención y Profilaxis",
        description: "Controles periódicos y medidas preventivas para una salud bucodental a largo plazo. Apostamos por el asesoramiento individual y el diagnóstico moderno.",
        treatments: [
          {
            title: "Control y asesoramiento",
            description: "Exámenes detallados y recomendaciones personales para unos dientes sanos."
          },
          {
            title: "Limpieza dental profesional",
            description: "Eliminación profunda de la placa dental para una sensación de limpieza y frescura."
          },
          {
            title: "Empastes",
            description: "Empastes de alta calidad que restauran sus dientes estética y funcionalmente."
          },
          {
            title: "Profilaxis infantil",
            description: "Prevención adaptada a los niños para proteger sus dientes de forma lúdica."
          }
        ]
      },
      {
        title: "Terapia del Dolor",
        description: "Tratamientos indoloros mediante técnicas suaves y las últimas tecnologías. Su bienestar es el centro de cada sesión.",
        treatments: [
          {
            title: "Tratamiento del dolor",
            description: "Alivio rápido y eficaz del dolor dental, adaptado individualmente a usted."
          },
          {
            title: "Extracción dental",
            description: "Extracción suave de dientes cuando no es posible otra solución."
          },
          {
            title: "Endodoncia",
            description: "Endodoncia precisa para salvar dientes inflamados y aliviar el dolor."
          },
          {
            title: "Problemas de la mandíbula",
            description: "Terapia específica para problemas de la articulación temporomandibular (ATM) para una mejor calidad de vida."
          }
        ]
      },
      {
        title: "Periodoncia",
        description: "Tratamiento profesional de las enfermedades de las encías para una salud bucodental estable. Las medidas tempranas evitan daños a largo plazo.",
        treatments: [
          {
            title: "Medidas de tratamiento",
            description: "Limpieza profesional y terapias para combatir eficazmente la inflamación de las encías."
          }
        ]
      },
      {
        title: "Para una sonrisa perfecta (Estética)",
        description: "Soluciones estéticas para una sonrisa segura, totalmente según sus deseos. Nuestros métodos son suaves y eficaces.",
        treatments: [
          {
            title: "Reconstrucción con composite",
            description: "Reconstrucción estética directa en una sola sesión – sin tallar, con técnica de estratificación a mano alzada."
          },
          {
            title: "Invisalign",
            description: "Alineadores transparentes para una corrección dental discreta y cómoda."
          },
          {
            title: "Blanqueamiento dental",
            description: "Blanqueamiento suave de sus dientes para una sonrisa blanca y radiante."
          },
          {
            title: "Férulas de descarga",
            description: "Férulas a medida para prevenir el bruxismo y proteger su dentadura."
          },
          {
            title: "Carillas",
            description: "Láminas de cerámica extrafinas para un aspecto perfecto y natural de sus dientes."
          },
          {
            title: "Coronas y puentes",
            description: "Prótesis dentales de alta calidad para la función y la estética en dientes dañados."
          }
        ]
      },
      {
        title: "Implantes",
        description: "La tecnología de implantes más moderna para una prótesis dental natural y duradera. Nuestros implantes le ofrecen comodidad y seguridad.",
        treatments: [
          {
            title: "Implantes individuales",
            description: "Sustitución de dientes individuales con implantes de alta calidad para una sensación natural."
          },
          {
            title: "Implantes múltiples",
            description: "Soluciones integrales de implantes para huecos dentales mayores o hileras de dientes completas."
          },
          {
            title: "Implantes inmediatos",
            description: "Implantes de carga inmediata para una rápida restauración de su función masticatoria."
          }
        ]
      }
    ]
  },

  // Benefits Section
  benefits: {
    title: "Sus beneficios: Excelencia, comodidad y una sonrisa radiante.",
    items: [
      {
        title: "Experiencia y competencia",
        description: "Dentistas cualificados con formación continua constante."
      },
      {
        title: "Tecnología de vanguardia",
        description: "Tratamientos precisos con radiografía digital y equipos innovadores."
      },
      {
        title: "Atención centrada en el paciente",
        description: "Tratamiento empático, como el que esperaría de un amigo."
      },
      {
        title: "Ambiente mediterráneo",
        description: "Un entorno relajado inspirado en la belleza de Mallorca."
      },
      {
        title: "Servicio multilingüe",
        description: "Tratamiento en alemán, inglés y español."
      },
      {
        title: "Ubicación central",
        description: "Fácilmente accesible en el corazón de Palma de Mallorca."
      }
    ]
  },

  // Approach Section
  approach: {
    title: "Odontología reinventada: Su bienestar, nuestra promesa.",
    text: "En SeaDent queremos que su visita al dentista sea algo especial. Nuestra misión es ofrecerle no solo tratamientos médicamente excelentes, sino también un ambiente en el que se sienta relajado y comprendido. Para nosotros esto significa:",
    points: [
      "Escuchamos: sus deseos y necesidades están en el centro de nuestra atención. Nos tomamos tiempo para un asesoramiento individual.",
      "Relajación y tratamientos indoloros: con los métodos más modernos y el enfoque en su bienestar, hacemos que los tratamientos sean lo más cómodos posible.",
      "La transparencia crea confianza: explicamos cada paso de su tratamiento de forma clara y comprensible para que se sienta seguro."
    ]
  },

  // Experience Section
  experience: {
    title: "Sus momentos de bienestar en SeaDent Mallorca.",
    text: "En SeaDent se trata de algo más que odontología: queremos que su visita se convierta en un momento de relajación. Nuestra clínica combina los tratamientos más modernos con un ambiente inspirado en la paz y la belleza de Mallorca.",
    points: [
      "Ambiente acogedor con colores mediterráneos y luz natural.",
      "Equipo amable y empático que le ofrece una cálida bienvenida.",
      "Tiempos de espera cortos gracias a una organización eficiente de la clínica.",
      "Zonas de espera cómodas con Wi-Fi, bebidas y plantas.",
      "Detalles relajantes como música suave durante el tratamiento."
    ]
  },

  // Social Proof Section
  socialProof: {
    title: "Lo que dicen nuestros pacientes",
    reviews: [
      {
        text: "Profesionalmente de primera, humanamente grandioso, aquí uno se siente realmente bien cuidado ❤️. Un enorme agradecimiento al dentista y a todo el equipo. Así es como me imagino una clínica moderna y acogedora 🦷🤗.",
        author: "Marcel"
      },
      {
        text: "Nunca he conocido a un dentista tan dedicado, cálido y honesto. Siempre se toma mucho tiempo, incluso fuera del horario habitual de la clínica, y está siempre disponible para sus pacientes. Los tratamientos son profesionales y se realizan con mucha empatía. Incluso después de la cita, se ocupa del seguimiento y quiere saber cómo te encuentras; eso es algo que no se puede dar por sentado. Un dentista absolutamente fantástico en el que puedes confiar plenamente. ¡Recomendación absoluta!",
        author: "Stefanie"
      },
      {
        text: "¡¡¡Dentista de primera!!! Por supuesto, tuve un dolor de muelas extremo justo durante las vacaciones después de un empaste que me habían hecho hacía unas semanas. No era posible esperar hasta que pudiera ir a mi dentista en Alemania. Conseguí una cita con Jan D. Heiringhoff de inmediato. Es súper simpático, escucha, hace preguntas y realizó el tratamiento de conducto necesario de forma excelente. Mi dentista en Alemania dijo después que hizo un trabajo estupendo con el tratamiento de conducto. No tuve problemas ni siquiera dolor durante o después del tratamiento. ¡Lo recomiendo totalmente!",
        author: "Hendrik"
      },
      {
        text: "Realmente me alegré mucho de recibir una respuesta rápida y sin complicaciones después de una noche sin dormir por un dolor de muelas agudo. El tratamiento también fue rápido y profesional. Es agradable que todavía haya médicos que trabajen también los sábados y que, además, sean muy amables y competentes. Muchas gracias.",
        author: "T."
      },
      {
        text: "Tratamiento de urgencia inmediato (!) y profesional. Transparente y de tú a tú. Muchas gracias al equipo, me sentí muy bien atendido. ADENDA (unos meses después): De vuelta en la clínica, esta vez para un blanqueamiento. Todo profesional y amable. ¡Simplemente una clínica recomendable! 👍",
        author: "Hubert"
      },
      {
        text: "Fui recibido y atendido con muchísima amabilidad. El Dr. Heiringhoff se tomó mucho tiempo y me lo explicó todo detalladamente. A petición mía, hizo 2 radiografías de mi nueva corona. Tenía miedo de tener una infección en la raíz. No fue así y pude irme tranquila. Recomiendo sin duda al Dr. Heiringhoff. Gracias por la rápida ayuda un domingo ☺️.",
        author: "Elke"
      },
      {
        text: "Sinceramente, mis dientes daban pena antes, tanto que prefería posar serio en las fotos antes que sonreír. ¡Pero entonces llegó Jan! El tío convirtió mi dentadura en una sonrisa digna de ver. Súper relajado, nada de miedo al dentista y con mucho amor por el detalle. Ahora vuelvo a sonreír como si acabara de salir de un anuncio de pasta de dientes. ¡Gracias, Jan, eres mi héroe dental!",
        author: "Patrick"
      },
      {
        text: "Muchas gracias por la rápida ayuda. Tuve una urgencia dental durante las vacaciones. Conseguí una cita de inmediato, donde me asesoraron y atendieron de maravilla. Recomendación de corazón.",
        author: "Simone"
      }
    ]
  },

  // CTA Section
  cta: {
    title: "Experimente una odontología que le dé prioridad.",
    text: "¿Está listo para una clínica dental que combine el profesionalismo con el confort mediterráneo? Reserve su cita en SeaDent Mallorca y descubra un nuevo tipo de odontología – ¡esperamos darle la bienvenida en Palma!",
    bookButton: "Reservar cita online",
    callButton: "Llámenos",
    visitInfo: "Visítenos: Avenida de Jaime III № 3, Palma, Mallorca."
  },

  // Services (Home page cards)
  services: {
    title: "Nuestros Servicios",
    subtitle: "Odontología Integral",
    implants: {
      title: "Implantes Dentales",
      description: "Solución duradera para la falta de dientes con implantes de titanio"
    },
    veneers: {
      title: "Carillas",
      description: "Transforme su sonrisa con carillas de porcelana personalizadas"
    },
    cleaning: {
      title: "Limpieza Profesional",
      description: "Limpieza profunda y prevención para una salud oral óptima"
    },
    crown: {
      title: "Coronas y Puentes",
      description: "Restauración de dientes dañados con coronas y puentes de alta calidad"
    },
    orthodontics: {
      title: "Ortodoncia",
      description: "Alinee sus dientes con tratamientos ortodónticos modernos"
    },
    surgery: {
      title: "Cirugía Oral",
      description: "Intervenciones quirúrgicas expertas en nuestros modernos quirófanos"
    }
  },

  // Technologies Section
  technologies: {
    title: "Tecnología Moderna",
    subtitle: "Equipamiento de última generación",
    intro: "En SeaDent, priorizamos una odontología personal, agradable e indolora mediante el uso de tecnología de vanguardia.",
    sections: [
      {
        title: "Odontología Digital",
        description: "Impresiones digitales e imágenes 3D para un diagnóstico y una planificación del tratamiento precisos.",
        benefits: [
          "Captura dental digital rápida y cómoda.",
          "Comodidad significativamente mayor que con las impresiones.",
          "Posibilidad de visualizar los resultados de su tratamiento.",
          "Contribuye a un tratamiento más rápido y agradable."
        ]
      },
      {
        title: "Láser Dental: La Luz Curativa",
        description: "Un láser dental es un instrumento versátil que reemplaza muchas herramientas convencionales y apoya la curación. Funciona de manera precisa, eficiente y segura. Beneficios del Láser Dental para usted:",
        benefits: [
          "Apoya la curación de encías, hueso y más.",
          "Permite intervenciones quirúrgicas menores.",
          "Ayuda en la esterilización de conductos radiculares.",
          "Se utiliza para detener el sangrado en procedimientos.",
          "Tratamiento efectivo de aftas y herpes.",
          "Apoya el tratamiento de la periodontitis.",
          "Ayuda en la desensibilización de cuellos dentales sensibles."
        ]
      },
      {
        title: "Tecnología de Implantes",
        description: "Sistemas de implantes avanzados para una integración óptima y un éxito a largo plazo.",
        benefits: [
          "Materiales biocompatibles de alta calidad",
          "Planificación guiada por ordenador para la máxima seguridad",
          "Resultados duraderos y de aspecto natural"
        ]
      },
      {
        title: "Microscopio Dental",
        description: "Precisión microscópica para tratamientos de endodoncia y procedimientos quirúrgicos finos.",
        benefits: [
          "Máxima precisión en los detalles",
          "Mayores tasas de éxito en los tratamientos de conducto",
          "Preservación de la mayor cantidad posible de estructura dental natural"
        ]
      }
    ],
    conclusion: "Al combinar estas tecnologías modernas con nuestro enfoque en la confianza y la transparencia, experimentará en SeaDent una odontología profesional, agradable y personal."
  },


  // Other sections
  implants: {
    title: "Implantes – Para una mejor calidad de vida",
    intro: "Los implantes dentales son la forma más moderna y natural de reponer los dientes perdidos. No solo ofrecen una estética perfecta, sino que también le devuelven la sensación y la seguridad de sus propios dientes. En nuestra clínica de Palma apostamos por los más altos estándares de calidad y los procedimientos más modernos.",
    benefitsTitle: "Ventajas de los implantes",
    benefit1: "Aspecto y sensación naturales, comparables a los propios dientes",
    benefit2: "Mejora de la función masticatoria y de la capacidad de hablar",
    benefit3: "Solución duradera con una alta tasa de éxito",
    benefit4: "Preservación de la estructura ósea de la mandíbula",
    qualityTitle: "Máxima calidad y precisión",
    quality: "Utilizamos únicamente materiales de alta calidad y procedimientos de planificación digital de última generación. Así le garantizamos un resultado preciso y duradero que se adapta perfectamente a usted.",
    experienceTitle: "Experiencia de tratamiento agradable",
    experience: "Gracias a las técnicas mínimamente invasivas y a la anestesia suave, el tratamiento con nosotros es especialmente delicado. Nuestro objetivo es que se sienta cómodo y seguro durante todo el proceso.",
    processTitle: "El camino hacia sus nuevos implantes",
    step1Title: "Consulta",
    step1: "Conversación detallada y planificación individual",
    step2Title: "Implantación",
    step2: "Procedimiento suave bajo anestesia local",
    step3Title: "Cicatrización",
    step3: "Integración del implante con el hueso de la mandíbula",
    step4Title: "Prótesis dental",
    step4: "Creación e inserción del reemplazo dental individual",
    foreignImplants: {
      title: "Problemas con implantes — también si se los colocaron en otra clínica",
      intro: "¿Le duele un implante, se ha aflojado la corona o nota la encía inflamada alrededor? Le atendemos aunque el implante se haya colocado en otra clínica o en otro país.",
      body: "Con radiografía digital 3D y planificación asistida por ordenador analizamos la situación de su implante con precisión: volvemos a fijar coronas sueltas, tratamos la inflamación de los tejidos (periimplantitis) y le decimos con honestidad qué opciones tiene. Especialmente si está de visita en Mallorca y surge un problema durante su estancia, no espere a volver a casa — una inflamación alrededor del implante empeora con el tiempo.",
      linkText: "Urgencia dental durante su estancia en Mallorca — guía paso a paso",
    },
  },
  veneers: {
    title: "Carillas – Para su sonrisa radiante",
    intro: "Las láminas cerámicas ultrafinas, conocidas como carillas, ofrecen una solución elegante para corregir permanentemente pequeñas imperfecciones estéticas en los dientes frontales. Ya se trate de decoloraciones, pequeños espacios o ligeras desalineaciones, le ayudamos a conseguir una sonrisa armoniosa y natural.",
    imageAlt: "Tratamiento de carillas en SeaDent Mallorca",
    description: "Las carillas son láminas fabricadas individualmente que se adhieren firmemente a la superficie del diente. Se caracterizan por su alta biocompatibilidad y una estética difícil de distinguir de los dientes naturales. En solo unas pocas sesiones, transformamos su sonrisa y le damos una nueva confianza en sí mismo."
  },
  composite: {
    title: "Reconstrucción directa con composite – Tu nueva sonrisa en una sola sesión",
    intro: "Reconstrucción directa y aditiva de tus dientes con composite del color del diente en técnica de estratificación a mano alzada – sin tallar, sin laboratorio, con resultado visible el mismo día.",
    heroAlt: "Comparación antes/después de la reconstrucción con composite en SeaDent Mallorca",
    heroCaption: "Antes y después en comparación directa. Reconstrucción con composite en los dientes anteriores superiores (lado derecho de la imagen), junto al lado sin tratar a la izquierda. La forma, longitud, color y luminosidad las adaptamos individualmente contigo.",
    whatIsTitle: "¿Qué es la reconstrucción directa con composite?",
    whatIsBody: "La reconstrucción directa con composite es un procedimiento moderno y mínimamente invasivo de odontología estética. Rediseñamos la forma, longitud, color y posición de tus dientes sin tallar, sin impresiones de laboratorio y sin provisionales. Un composite de alta calidad del color del diente se aplica directamente sobre el diente en capas finas, se modela a mano y se polimeriza con luz.",
    whatIsResult: "Verás el resultado el mismo día.",
    distinctionTitle: "Importante: no son carillas",
    distinctionBody: "En las carillas cerámicas convencionales hay que tallar tejido dental sano para alojar la lámina. Nuestro procedimiento es puramente aditivo: añadimos material sin reducir el diente natural – y es totalmente reversible.",
    indicationsTitle: "¿Para quién es?",
    indications: [
      { title: "Corrección estética de dientes anteriores", body: "Bordes astillados, longitudes irregulares, asimetrías y anomalías de forma en los dientes visibles." },
      { title: "Cierre de diastemas", body: "Incluso espacios de hasta 6–7 mm pueden cerrarse sin ortodoncia." },
      { title: "Reconstrucción de dientes desgastados", body: "Recuperamos la forma y longitud original en casos de bruxismo, erosión o desgaste por edad." },
      { title: "Smile makeover aditivo", body: "Rediseño armónico de varios dientes anteriores en una única sesión." }
    ],
    whyTitle: "Lo que hace especial a nuestro método",
    whyBuildupAlt: "Macro fotorrealista de la técnica de estratificación del composite con fotopolimerización",
    why: [
      { title: "Resultado en una sesión", body: "30–60 minutos por diente. Un makeover completo del frente anterior (6–8 dientes) se realiza en una sola cita. Sin laboratorio, sin segunda sesión, sin provisional." },
      { title: "Técnica de estratificación a mano alzada", body: "Las masas de dentina y esmalte se modelan en capas a mano – como en un diente natural. El resultado tiene verdadera profundidad, opalescencia y refracción de la luz." },
      { title: "Conservador y reversible", body: "Tu sustancia dental se mantiene íntegra. Todas las opciones futuras siguen disponibles." }
    ],
    processTitle: "El procedimiento paso a paso",
    processIllustrationAlt: "Ilustración de la estratificación del composite con lámpara de polimerización",
    process: [
      { title: "Consulta y análisis", body: "Exploración clínica, valoración de la oclusión, conversación sobre tus deseos." },
      { title: "Selección de color y forma", body: "Elección de los tonos de composite para las capas de dentina y esmalte." },
      { title: "Preparación", body: "Limpieza de la superficie, aislamiento con dique de goma, acondicionamiento adhesivo." },
      { title: "Estratificación", body: "Aplicación policromática por capas con fotopolimerización de cada capa." },
      { title: "Acabado y pulido a alto brillo", body: "Microtextura anatómica y brillo natural." },
      { title: "Revisión final y resultado", body: "Control visual, control de mordida, entrega." }
    ],
    aftercareTitle: "Después del tratamiento y cuidados",
    aftercare: [
      "Sin tiempo de espera – puedes comer y hablar de inmediato",
      "Primeras 24–48 horas: evita alimentos y bebidas con alto poder colorante (café, vino tinto, té, curry, frutos rojos)",
      "Cuidado como tus dientes naturales – cepillado dos veces al día, higiene interdental, limpiezas profesionales periódicas",
      "Evita masticar hielo o abrir envases con los dientes anteriores",
      "En caso de bruxismo: férula de descarga personalizada como protección"
    ],
    longevityTitle: "Duración",
    longevityBody: "Con buena higiene oral y revisiones periódicas, las reconstrucciones directas de composite pueden durar hasta 20 años. El composite se puede repulir, ampliar y reparar de forma puntual – sin sustitución completa.",
    benefitsTitle: "Ventajas de un vistazo",
    benefits: [
      { label: "1 sola sesión", value: "Resultado visible al instante" },
      { label: "Sin tallado", value: "Conservación del 100 % del diente natural" },
      { label: "Estratificación", value: "Aspecto natural indistinguible del diente real" },
      { label: "Reversible", value: "Todas las futuras opciones siguen disponibles" },
      { label: "Reparable", value: "Pequeñas correcciones sin sustitución total" },
      { label: "Precio justo", value: "Considerablemente más asequible que las soluciones de laboratorio" }
    ],
    faqTitle: "Preguntas frecuentes",
    faq: [
      { q: "¿Duele el tratamiento?", a: "No. Como no se utiliza fresa, en la mayoría de los casos no es necesaria anestesia." },
      { q: "¿Cuánto dura una sesión?", a: "Entre 30 y 60 minutos por diente. Un smile makeover completo se planifica en un solo día." },
      { q: "¿Se nota que no es mi diente?", a: "Con una correcta técnica de estratificación con masas de dentina y esmalte, el composite es ópticamente indistinguible del esmalte natural." },
      { q: "¿Cómo cuido los dientes reconstruidos?", a: "Igual que tus dientes naturales. Es importante acudir a limpiezas profesionales cada seis meses." },
      { q: "¿El material se mancha?", a: "El composite moderno es muy estable en color. Las pequeñas manchas superficiales suelen eliminarse con un pulido." },
      { q: "¿Cuánto dura el resultado?", a: "Hasta 20 años con un cuidado adecuado. Las reparaciones son siempre posibles, sin tener que rehacer toda la restauración." },
      { q: "¿Y si se rompe un trozo?", a: "Reparamos la zona afectada de forma puntual, sin rehacer toda la restauración." },
      { q: "¿Soy candidato/a?", a: "Lo evaluamos en una consulta personal. En casos de desgaste severo o problemas de mordida, te explicaremos abiertamente cuál es el método más adecuado." },
      { q: "¿Qué precio tiene?", a: "Depende del número de dientes y la complejidad. Recibes un presupuesto por escrito antes de empezar." }
    ],
    ctaTitle: "¿Listo para tu nueva sonrisa?",
    ctaBody: "Pide una consulta personal. Te escuchamos, examinamos con detalle y te decimos con honestidad lo que es posible.",
    ctaButton: "Reservar consulta online",
    ctaCall: "O llámanos"
  },
  legalNotice: {
    title: "Aviso Legal",
    german: {},
    english: {},
    spanish: {}
  },

  // Panel SmartAI — recepción digital en la web pública
  smartai: {
    // --- Layout v2: reservar y gestionar la cita dentro del panel -------------
    v2: {
      greeting: 'Buenos días. ¿En qué podemos ayudarle?',
      greetingSub: 'Elija un asunto — o escríbanoslo abajo.',
      greetingSubNoChat: 'Elija un asunto.',
      groupAppointment: 'Cita',
      book: 'Reservar cita',
      bookHint: 'Elija aquí mismo entre las horas libres',
      reschedule: 'Cambiar',
      cancel: 'Anular',
      groupHelp: 'Ayuda y contacto',
      help: 'Hacer una pregunta',
      callback: 'Que me llamen',
      emergency: 'Urgencia dental — llame ahora',
      emergencyHint: 'Le devolvemos la llamada en menos de 30 minutos',
      askPlaceholder: 'Escriba su pregunta o su consulta',
      backHome: 'Inicio',
      manageIntro: 'Para cambiar la cita necesitamos una confirmación por correo — las citas son datos de salud personales.',
      cancelIntro: 'Para anular la cita necesitamos una confirmación por correo — las citas son datos de salud personales.',
      pickTreatment: '¿De qué se trata?',
      minutes: 'minutos',
      change: 'Cambiar',
      loading: 'Un momento…',
      free: 'libres',
      moreDays: 'Más',
      noDays: 'Ahora mismo no hay horas libres en línea. Llámenos — por teléfono solemos encontrar algo: 603 31 96 48',
      noSlots: 'Ese día ya no queda nada libre.',
      toContact: 'Continuar con sus datos',
      holdHint: 'Le reservamos esta hora durante 10 minutos',
      holdFailed: 'No hemos podido reservar esta hora — termine la reserva rápido, por favor.',
      slotGone: 'Acaban de ocupar esta hora. Elija otra, por favor.',
      errorGeneric: 'No ha funcionado. Inténtelo de nuevo o llámenos: 603 31 96 48',
      fieldName: 'Nombre',
      fieldEmail: 'Correo electrónico',
      emailHint: 'Aquí le enviamos la confirmación con el enlace para cambiar o anular la cita.',
      fieldPhone: 'Teléfono',
      fieldMessage: 'Comentario',
      optional: 'opcional',
      submit: 'Solicitar la cita',
      submitting: 'Enviando…',
      privacyHint: 'Sus datos van directamente a la clínica y nunca pasan por una IA.',
      doneTitle: 'Cita solicitada',
      doneBody: 'En breve recibirá la confirmación por correo. Incluye el enlace con el que puede cambiar o anular la cita cuando quiera.',
      doneNoMail: 'Hemos recibido su cita. El correo de confirmación no se ha podido entregar — llámenos un momento para comprobar la dirección.',
      close: 'Listo',
      openUntil: 'Abierto hasta las',
      closedHoliday: 'Vacaciones · cerrado hasta el',
      closedNow: 'Cerrado · abrimos a las',
      oclock: '',
      labelPractice: 'Clínica',
      hoursLine: 'Lu–Vi 09:00–18:00',
      labelEmergency: 'Urgencias',
      emergencyLine: 'las 24 horas, también los fines de semana',
      labelAddress: 'Dirección',
      call: 'Llamar',
      directions: 'Cómo llegar',
      faqTitle: 'Preguntas frecuentes',
      faqStarters: [
        '¿Dónde puedo aparcar cerca?',
        '¿Cubre mi seguro de viaje el tratamiento?',
        '¿Puedo conseguir cita para hoy?',
      ],
      callbackTitle: 'Solicitar una llamada',
      callbackHint: 'Le llamamos a la hora que prefiera',
      requestCode: 'Solicitar código',
      fastPathTitle: 'Lo más rápido, sin código',
      fastPathBody: 'En su correo de confirmación y de recordatorio está el enlace «Gestionar cita». Con un clic ya está dentro.',
      enumerationHint: 'Sin confirmación no mostramos ningún dato de la cita — tampoco si la dirección nos consta.',
      codeSent: 'Hemos enviado un código de 6 dígitos a {{email}}.',
      codeValidity: 'Válido 10 minutos',
      codeResend: 'Enviar un código nuevo',
      codeConfirm: 'Confirmar código',
      checking: 'Comprobando…',
      changeEmail: 'Usar otra dirección de correo',
      codeInvalid: 'El código no es correcto.',
      codeExpired: 'El código ha caducado. Solicite uno nuevo, por favor.',
      codeLocked: 'Demasiados intentos. Solicite un código nuevo, por favor.',
      yourAppointments: 'Sus citas',
      noAppointments: 'No hay ninguna cita próxima para esta dirección. Si está seguro de que la tiene, llámenos: 603 31 96 48',
      currentAppointment: 'Su cita actual',
      pickNewTime: 'Elegir una hora nueva',
      confirmReschedule: 'Cambiar la cita',
      backToList: 'Volver al resumen',
      cancelConfirm: '¿Seguro que quiere anular esta cita?',
      cancelYes: 'Sí, anular',
      cancelNo: 'Mantener',
      cancelBlocked: 'Esta cita ya no se puede anular por internet. Llámenos, por favor: 603 31 96 48',
      rescheduleBlocked: 'Esta cita ya no se puede cambiar por internet. Llámenos, por favor: 603 31 96 48',
      cancelDone: 'Cita anulada',
      cancelDoneBody: 'La cita queda anulada y recibirá la confirmación por correo. La hora pasa a otra persona — gracias por avisarnos a tiempo.',
      rescheduleDone: 'Cita cambiada',
      rescheduleDoneBody: 'La nueva cita está confirmada. Le enviamos por correo todos los datos.',
    },
    buttonLabel: '¿Cita, receta o pregunta?',
    title: 'Recepción digital',
    aiTransparency: 'Asistente digital — no es una persona. En caso de urgencia, llame por teléfono.',
    close: 'Cerrar',
    back: 'Atrás',
    homeIntro: '¿En qué podemos ayudarle?',
    actions: {
      book: 'Reservar cita',
      bookHint: 'Online, las 24 horas',
      manage: 'Cambiar / cancelar cita',
      callback: 'Solicitar llamada',
      callbackHint: 'Le llamamos nosotros',
      documents: 'Receta y documentos',
      documentsHint: 'Receta, factura, informe',
    },
    manage: {
      title: 'Cambiar o cancelar su cita',
      emailInfo: 'Indique el correo electrónico con el que reservó. Le enviaremos el enlace «Gestionar cita» para que pueda cambiarla o cancelarla usted mismo.',
      emailLabel: 'Correo electrónico',
      submit: 'Enviarme el enlace',
      sending: 'Enviando…',
      sentTitle: 'Correo en camino',
      sent: 'Si hay citas próximas para esta dirección, recibirá en unos minutos un correo con el enlace de gestión. Revise la carpeta de spam si es necesario.',
      error: 'No ha funcionado. Inténtelo de nuevo o llámenos: 603 31 96 48',
      phoneHint: '¿Sin acceso a ese buzón? Llámenos:',
    },
    form: {
      callbackTitle: 'Solicitar llamada',
      documentsTitle: 'Solicitar receta y documentos',
      docTypeLabel: 'Tipo de solicitud',
      docPrescription: 'Receta',
      docDocument: 'Documento (p. ej. factura, informe)',
      name: 'Nombre *',
      phone: 'Teléfono *',
      email: 'Correo electrónico (opcional)',
      preferredTime: 'Hora preferida para la llamada (opcional)',
      message: 'Su solicitud (opcional)',
      sending: 'Enviando…',
      submit: 'Enviar',
      successTitle: 'Solicitud enviada',
      success: '¡Gracias! El equipo de la clínica se pondrá en contacto con usted en breve.',
      backHome: 'Volver al inicio',
      error: 'No ha funcionado. Inténtelo de nuevo o llámenos: 603 31 96 48',
      privacy: 'Sus datos se utilizan únicamente para tramitar su solicitud. Más información en la política de privacidad.',
    },
    chat: {
      homeLabel: 'O simplemente haga su pregunta:',
      placeholder: 'Su pregunta…',
      ask: 'Preguntar',
      send: 'Enviar',
      intro: 'Haga su pregunta — p. ej. sobre horarios, tratamientos o cómo llegar. No incluya datos personales (nombre, teléfono) en la pregunta.',
      piiHint: 'No incluya datos personales (nombre, teléfono) en la pregunta.',
      error: 'No ha funcionado. Inténtelo de nuevo o use los botones de arriba.',
      forward: 'Enviar la pregunta al equipo',
      forwarded: 'Enviada — el equipo se pondrá en contacto con usted.',
      forwardError: 'No se pudo enviar — llámenos si lo desea: 603 31 96 48',
      actionGeneric: 'Continuar',
      actions: {
        booking: 'Empezar la reserva',
        manage: 'Gestionar cita',
        callback: 'Solicitar llamada',
        documents: 'Solicitar receta y documentos',
      },
    },
  }
};